import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      window.history.replaceState(null, "", window.location.pathname);
      api
        .post("/auth/session", {}, { headers: { "X-Session-ID": sid } })
        .then((r) => {
          localStorage.setItem("jx_token", r.data.token);
          setUser(r.data.user);
          const u = r.data.user;
          window.location.assign(u.role === "seller" ? "/seller" : "/buyer");
        })
        .catch(() => {})
        .finally(() => setLoading(false));
      return;
    }
    const token = localStorage.getItem("jx_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("jx_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("jx_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("jx_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("jx_token");
    setUser(null);
  };

  // Adopt a session handed back by a non-login endpoint (e.g. the
  // password-reset flow signs the user straight in).
  const applySession = (token, u) => {
    localStorage.setItem("jx_token", token);
    setUser(u);
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };

  const becomeSeller = async () => {
    const { data } = await api.post("/auth/become-seller");
    localStorage.setItem("jx_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser, becomeSeller, loginWithGoogle, applySession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
